import { getUrlParameter, getHashParameter, joinPath } from '../core/utils';
import Paella from '../Paella';
import { Config } from '../core/Config';

export async function defaultLoadConfigFunction(configUrl: string, player: Paella) {
    player.log.debug("Using default configuration loading function.");
    const response = await fetch(configUrl);
    return response.json();
}

export async function defaultGetVideoIdFunction(config: Config, player: Paella) {
    player.log.debug("Using default getVideoId function");
    return getHashParameter("id") || getUrlParameter("id") || config.fallbackId;
}

export async function defaultGetManifestUrlFunction(repoUrl: string, videoId: string, config: Config, player: Paella) {
    player.log.debug("Using default getManifestUrl function");
    return joinPath([repoUrl,videoId]);
}

export async function defaultGetManifestFileUrlFunction(manifestUrl: string, manifestFileName: string, config: Config, player: Paella) {
    player.log.debug("Using default getManifestFileUrl function");
    return joinPath([manifestUrl,manifestFileName]);
}

export async function defaultLoadVideoManifestFunction(videoManifestUrl: string, config: Config, player: Paella) {
    player.log.debug("Using default loadVideoManifest function");
    const response = await fetch(videoManifestUrl);
    if (response.ok) {
        try {
            return await response.json();
        }
        catch (err) {
            throw new Error(player.translate("Error parsing video manifest. Unexpected file format."));
        }
    }
    else {
        throw new Error(player.translate("Error loading video manifest: $1 $2", [response.status, response.statusText]));
    }
}
